

// src/firebase.js
import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage, ref } from "firebase/storage";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDUJAQAU4rQoppqZazFX8UycHZPsu9F7mw",
  authDomain: "community-f4768.firebaseapp.com",
  projectId: "community-f4768",
  // storageBucket: "community-f4768.firebasestorage.app",
  storageBucket: "community-f4768.firebasestorage.app",
  messagingSenderId: "1040991869066",
  appId: "1:1040991869066:web:5094a77e12db8e7f27b573",
  measurementId: "G-RLQ99R9WRS"
};


// export const app = initializeApp(firebaseConfig);
const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// Either rely on storageBucket above:
export const storage = getStorage(app);
// (Optional explicit bucket):
// export const storage = getStorage(app, "gs://community-f4768.appspot.com");
